import { render, staticRenderFns } from "./SchematicOptionMenu.vue?vue&type=template&id=eb3d81ca&scoped=true"
import script from "./SchematicOptionMenu.vue?vue&type=script&lang=js"
export * from "./SchematicOptionMenu.vue?vue&type=script&lang=js"
import style0 from "./SchematicOptionMenu.vue?vue&type=style&index=0&id=eb3d81ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3d81ca",
  null
  
)

export default component.exports